<script lang="ts">
    import { onMount, onDestroy } from 'svelte'

    export let targetDate

    let days = 0
    let hours = 0
    let minutes = 0
    let seconds = 0

    let timerInterval

    function startTimer() {
        const targetTime = new Date(targetDate).getTime()

        timerInterval = setInterval(() => {
            const now = new Date().getTime()
            const timeRemaining = targetTime - now

            days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24))
            hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
            minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60))
            seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000)

            if (timeRemaining <= 0) {
                clearInterval(timerInterval)
            }
        }, 1000)
    }

    onMount(() => {
        startTimer()
    })

    onDestroy(() => {
        clearInterval(timerInterval)
    })
</script>

<div class="timer">
    {#if days > 0}{days}d{/if}
    {#if hours > 0}{hours}h{/if}
    {#if minutes > 0}{minutes}m{/if}
    {#if seconds > 0}{seconds}s{/if}
</div>

<style>
    .timer {
        text-transform: none;
    }
</style>
